import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'

import { MetricsEvents } from '@/constants/metricsEvents'
import { resolveScreenName } from '@/presentation/router/screenNameMapper'
import { sendMetrics } from '@/presentation/utils/sendMetrics'

/**
 * Emite `PLANNINGAPP_PAGE_ENTERED` a cada entrada em tela.
 *
 * Deve ser chamado **uma única vez**, em um componente que viva o app inteiro dentro do
 * `<BrowserRouter>` (hoje o `DrawerPresenter`). Não usar no `DrawerRouter`: ele remonta a cada
 * troca de seção por causa do `key={resetKey}` do `AppErrorBoundary`, o que zeraria o
 * histórico de tela anterior.
 */
export const usePageEnteredMetrics = () => {
  const { pathname, search } = useLocation()

  // Guarda a última tela emitida: serve de `previousScreen` e de guarda contra emissão
  // duplicada quando um redirect gera duas mudanças de location para a mesma tela.
  const lastScreenRef = useRef<string | null>(null)

  useEffect(() => {
    const match = resolveScreenName(pathname, search)

    if (!match || match.screen === lastScreenRef.current) return

    sendMetrics(MetricsEvents.PAGE_ENTERED, {
      screen: match.screen,
      path: pathname,
      previousScreen: lastScreenRef.current ?? 'none',
      ...(match.mode ? { mode: match.mode } : {})
    })

    lastScreenRef.current = match.screen
  }, [pathname, search])
}
